import { message, Progress, Upload } from "antd";
import { PictureOutlined, PlusOutlined } from "@ant-design/icons";
import { useState } from "react";
import { get } from "lodash";
import axiosInstance, { endpoints } from "services/axios";
import { partnerPhotoUrl } from "utils/constants";

interface Props {
  photoId?: string;
  onChange?: (photoId: string | undefined) => void;
}

const TILE_CLASS =
  "w-[172px] h-[196px] rounded-2xl overflow-hidden flex flex-col items-center justify-center gap-1 cursor-pointer select-none";

const truncateFileName = (name: string, max = 9) => (name.length > max ? `${name.slice(0, max - 1)}…` : name);

const PhotoUpload = ({ photoId, onChange }: Props) => {
  const [uploading, setUploading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [errorFile, setErrorFile] = useState<string | undefined>();

  const beforeUpload = async (file: File) => {
    setUploading(true);
    setErrorFile(undefined);
    setProgress(0);
    try {
      const formData = new FormData();
      formData.append("file", file);
      const res = await axiosInstance.post(endpoints.partner.uploadPhoto, formData, {
        onUploadProgress: (evt) => {
          if (evt.total) setProgress(Math.round((evt.loaded * 100) / evt.total));
        },
      });
      const id = get(res, "data.data");
      if (!id) throw new Error("Rasm yuklandi, lekin id qaytmadi");
      onChange?.(id);
    } catch (e) {
      setErrorFile(file.name);
      message.error("Rasm yuklashda xatolik");
    } finally {
      setUploading(false);
    }
    return false;
  };

  if (errorFile)
    return (
      <Upload showUploadList={false} beforeUpload={beforeUpload} accept="image/*">
        <div className={`${TILE_CLASS} border border-red-400 px-2 text-red-500`}>
          <PictureOutlined />
          <span className="text-[10px] leading-none truncate max-w-full">{truncateFileName(errorFile)}</span>
        </div>
      </Upload>
    );

  if (uploading)
    return (
      <div className={`${TILE_CLASS} border border-gray-300 px-3 text-gray-500 box-border`}>
        <span className="text-[10px] leading-none">Yuklanmoqda...</span>
        <Progress percent={progress} showInfo={false} size="small" style={{ width: 64 }} className="leading-none" />
      </div>
    );

  if (photoId)
    return (
      <Upload showUploadList={false} beforeUpload={beforeUpload} accept="image/*">
        <div className={TILE_CLASS}>
          <img src={partnerPhotoUrl(photoId)} alt="" className="w-full h-full object-cover" />
        </div>
      </Upload>
    );

  return (
    <Upload showUploadList={false} beforeUpload={beforeUpload} accept="image/*">
      <div className={`${TILE_CLASS} border border-dashed border-gray-400 px-3 text-gray-400 hover:border-primary hover:text-primary`}>
        <PlusOutlined style={{ fontSize: 22 }} />
        <span className="text-[12px] leading-tight text-center px-2">Profil rasmini yuklash</span>
      </div>
    </Upload>
  );
};

export default PhotoUpload;
